module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-plugin-form order-voucher"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success),
      expression: "success"
    }],
    staticClass: "text-container"
  }, [_c('h2', [_vm._v("Danke für deine Bestellung beim Öpfelchasper.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "text-container"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "order-address-form__link--before",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showForm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Zurück\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.success && !_vm.error)),
      expression: "(!success && !error)"
    }]
  }, [_c('h2', {
    staticClass: "order-address-form__heading"
  }, [_vm._v("\n            Beträge\n        ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.validateForm
    }
  }, [_c('div', {
    staticClass: "form-group order-voucher__amounts"
  }, [_c('div', {
    staticClass: "order-voucher__amounts--predefined"
  }, _vm._l((_vm.amountsPredefined), function(amount, index) {
    return _c('div', {
      key: ("amount-" + index),
      staticClass: "radio"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.amountSelected),
        expression: "amountSelected"
      }],
      attrs: {
        "name": "amount",
        "type": "radio"
      },
      domProps: {
        "checked": index === 0,
        "value": amount,
        "checked": _vm._q(_vm.amountSelected, amount)
      },
      on: {
        "change": function($event) {
          _vm.amountSelected = amount
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-radio"
    }), _vm._v("\n                            " + _vm._s(amount) + " CHF\n                        ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "order-voucher__amounts--custom"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountSelected),
      expression: "amountSelected"
    }],
    attrs: {
      "name": "amount",
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.amountSelected, "0")
    },
    on: {
      "change": function($event) {
        _vm.amountSelected = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n                                Eigener Betrag\n                            ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.amountSpecific),
      expression: "amountSpecific",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control order-voucher__amounts__custom",
    class: {
      'error': _vm.$v.amountSpecific.$error
    },
    attrs: {
      "name": "amount-custom",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.amountSpecific)
    },
    on: {
      "focus": _vm.setSpecificAmount,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.amountSpecific = $event.target.value.trim()
      }, _vm.updateSpecificAmount],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('address-form', {
    ref: "addressForm",
    attrs: {
      "validate-form": _vm.validateForm,
      "comment-text": 'Hier kannst du eine Nachricht an den Beschenkten eingeben.',
      "disable-early-invoice": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-address-plugin-form__btn-container"
  }, [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validateForm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Gutschein bestellen\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Vielen Dank für deine Bestellung beim Öpfelchasper, wir bearbeiten sie so schnell wie möglich."), _c('br'), _vm._v("\n            Die Bestellbestätigung erhältst du schon bald per E-Mail."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n            Hast du noch Fragen? Wir beantworten dir sie gerne unter "), _c('a', {
    attrs: {
      "href": "tel:+41438186152"
    }
  }, [_vm._v("043 818 61 52")]), _vm._v(" oder per E-Mail unter "), _c('a', {
    attrs: {
      "href": "mailto:info@oepfelchasper.ch"
    }
  }, [_vm._v("info@oepfelchasper.ch")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Deine Bestellung konnte nicht übermittelt werden."), _c('br'), _vm._v("\n            Bitte versuche es später noch einmal oder kontaktiere uns per Telefon oder E-Mail:"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+41438186152"
    }
  }, [_vm._v("043 818 61 52")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@oepfelchasper.ch"
    }
  }, [_vm._v("info@oepfelchasper.ch")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4197dd36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Voucher/Voucher.vue
// module id = 907
// module chunks = 0